import { RecipeIngredientType } from "../../../../config/enums/IngredientType.enum";

export interface IngredientPercentageItem {
  percentage: number;
}

export interface CalculatedProductSalesUnitItem extends IngredientPercentageItem {
  _id?: string;
  salesUnitId: string;
  productId?: string;
  productName?: string;
  salesUnitName?: string;
}

export interface GenericIngredientItem extends IngredientPercentageItem {
  _id?: string;
  ingredientId: number;
  ingredientName?: string;
}

export interface CalculatedIngredientItem extends IngredientPercentageItem {
  _id?: string;
  ingredientId?: string;
  supplierId?: string;
  ingredientName?: string;
}

export interface RecipeAddIngredientModalProps {
  visibleModal: boolean;
  setVisibleModal: (visible: boolean) => void;
  recipeId: string;
  recipeDataRefetch: () => void;
  calculatedProductSalesUnit: CalculatedProductSalesUnitItem[];
  genericIngredient: GenericIngredientItem[];
  calculatedIngredient?: CalculatedIngredientItem[];
  usedColors: string[];
}

export interface IngredientDraftRow {
  ingredientType: RecipeIngredientType | "";
  productUnitKey: string;
  ingredientId: string;
  percentage: number | "" | string;
  descriptionOpen: boolean;
  saved: boolean;
  sourceId?: string;
  isExisting?: boolean;
  displayName?: string;
}

export interface IngredientDraftFormValues {
  drafts: IngredientDraftRow[];
}

export interface ProductUnitOption {
  id: string;
  title: string;
  value: string;
  productId: string;
  salesUnitId: string;
  disabled: boolean;
}

export interface GenericIngredientOption {
  id: number;
  title: string;
  value: number;
  disabled: boolean;
  description: string | null;
  status: string | null;
  record: string | null;
  allocationMethod: string | null;
  databaseName: string | null;
}

export const CATEGORY_LABELS: Record<RecipeIngredientType, string> = {
  [RecipeIngredientType.OWN_PRODUCT]: "Own Product",
  [RecipeIngredientType.GENERIC_INGREDIENT]: "Generic",
  [RecipeIngredientType.CALCULATED_INGREDIENT]: "Calculated Ingredient"
};
